"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var colors_1 = require("../colors");
var Reset = function (_a) {
    var type = _a.type, width = _a.width, height = _a.height, fill = _a.fill;
    switch (type) {
        case 'line':
        default:
            return (React.createElement("svg", { width: width, height: height, viewBox: "0 0 40 40", fill: "none" },
                React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.15611 11.9934L9.15611 5.45456L5.45453 5.45456L5.45453 18.2572L18.2626 18.2572L18.2626 14.5572L11.7947 14.5572C13.7245 11.5334 17.1098 9.52823 20.9638 9.52823C26.9661 9.52823 31.8318 14.3919 31.8318 20.3917C31.8318 26.3914 26.9661 31.2551 20.9638 31.2551C16.9412 31.2551 13.4291 29.0705 11.5498 25.8234L7.52653 25.8234C9.67616 31.1318 14.8824 34.8762 20.9638 34.8762C28.9669 34.8762 35.4545 28.3914 35.4545 20.3917C35.4545 12.3919 28.9669 5.90709 20.9638 5.90709C16.0928 5.90709 11.7832 8.30935 9.15611 11.9934Z", fill: fill })));
    }
};
Reset.propTypes = {
    type: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fill: PropTypes.string,
};
Reset.defaultProps = {
    type: 'solid',
    width: 40,
    height: 40,
    fill: colors_1.grey5,
};
exports.default = Reset;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmVzZXQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaWNvbnMvUmVzZXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsNkJBQStCO0FBQy9CLHNDQUF3QztBQUV4QyxvQ0FBZ0M7QUFRaEMsSUFBTSxLQUFLLEdBQXlCLFVBQUMsRUFBMkI7UUFBMUIsY0FBSSxFQUFFLGdCQUFLLEVBQUUsa0JBQU0sRUFBRSxjQUFJO0lBQzdELFFBQVEsSUFBSSxFQUFFO1FBQ1osS0FBSyxNQUFNLENBQUM7UUFDWjtZQUNFLE9BQU8sQ0FDTCw2QkFBSyxLQUFLLEVBQUUsS0FBSyxFQUFFLE1BQU0sRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFDLFdBQVcsRUFBQyxJQUFJLEVBQUMsTUFBTTtnQkFDaEUsOEJBQ0UsUUFBUSxFQUFDLFNBQVMsRUFDbEIsUUFBUSxFQUFDLFNBQVMsRUFDbEIsQ0FBQyxFQUFDLG1nQkFBbWdCLEVBQ3JnQixJQUFJLEVBQUUsSUFBSSxHQUNWLENBQ0UsQ0FDUCxDQUFDO0tBQ0w7QUFDSCxDQUFDLENBQUM7QUFFRixLQUFLLENBQUMsU0FBUyxHQUFHO0lBQ2hCLElBQUksRUFBRSxTQUFTLENBQUMsTUFBYTtJQUM3QixLQUFLLEVBQUUsU0FBUyxDQUFDLFNBQVMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxNQUFNLEVBQUUsU0FBUyxDQUFDLE1BQU0sQ0FBQyxDQUFRO0lBQ3ZFLE1BQU0sRUFBRSxTQUFTLENBQUMsU0FBUyxDQUFDLENBQUMsU0FBUyxDQUFDLE1BQU0sRUFBRSxTQUFTLENBQUMsTUFBTSxDQUFDLENBQVE7SUFDeEUsSUFBSSxFQUFFLFNBQVMsQ0FBQyxNQUFNO0NBQ3ZCLENBQUM7QUFFRixLQUFLLENBQUMsWUFBWSxHQUFHO0lBQ25CLElBQUksRUFBRSxPQUFPO0lBQ2IsS0FBSyxFQUFFLEVBQUU7SUFDVCxNQUFNLEVBQUUsRUFBRTtJQUNWLElBQUksRUFBRSxjQUFLO0NBQ1osQ0FBQztBQUVGLGtCQUFlLEtBQUssQ0FBQyJ9


//////////////////
// WEBPACK FOOTER
// ./node_modules/@riiid/santa-closet-web/icons/Reset.js
// module id = 91
// module chunks = 0